const NS = 'NextTopicBlock';
const CLS = 'nextTopicBlock';

import { fullWindowHeightMixinBlock } from '../../mixins/fullWindowHeightMixinBlock/fullWindowHeightMixinBlock';

export class NextTopicBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$cards = this.$element.find(`.${CLS}-card`);
		this.$heading = this.$element.find(`.${CLS}-heading`);
		this.$nextCard = this.$cards.filter(`.${CLS}-card--next`);
		this.$previousCard = this.$cards.filter(`.${CLS}-card--previous`);
		this.$radialWidget = this.$element.find('.progressRadialWidget');

		this.$cards.on('click', (event) => {
			if($(event.currentTarget).attr('data-card-disabled') === 'true') {
				this.$element.trigger(`${CLS}.card.disabled.clicked`);
			}

			return !($(event.currentTarget).attr('data-card-disabled') === 'true'); // This cancels the click event if data-card-disabled is true
		});

		this.$element.on(`${CLS}.card.previous.disable`, (event, params) => {
			this.$previousCard.attr('data-card-disabled', params.disable);
		});

		this.$element.on(`${CLS}.card.next.disable`, (event, params) => {
			this.$nextCard.attr('data-card-disabled', params.disable);
		});

		this.$element.on('nextTopicBlock.percentage.update', (event, params) => {
			this.$radialWidget.trigger('progressRadialWidget.update', {
				percentage: params.percentage
			});

			if(params.percentage === 100) {
				this.$heading.attr('data-completed', true);
			}
			else {
				this.$heading.attr('data-completed', false);
			}
		});

		this.initFullWindowHeight(this);
	}
}

Object.assign(NextTopicBlock.prototype, fullWindowHeightMixinBlock);
